<!-- ==========================================
     TOP BAR FIGMA - PREMIÈRE BARRE
     ==========================================

     Spécifications exactes Figma :
     - Background vert #22A922
     - Langues + FAQ alignés à droite
     - Icône shield-exclamation pour FAQ
     ========================================== -->

<div class="top-bar-figma">
  <div class="top-bar-container">

    <!-- Sélecteur de langue Figma (spécifications exactes) -->
    <div class="language-selector-figma">
      <button
        class="lang-btn-figma"
        [class.active]="currentLanguage === 'fr'"
        (click)="setLanguage('fr')"
        type="button"
        aria-label="Français">
        FR
      </button>
      <button
        class="lang-btn-figma"
        [class.active]="currentLanguage === 'en'"
        (click)="setLanguage('en')"
        type="button"
        aria-label="English">
        EN
      </button>
      <button
        class="lang-btn-figma"
        [class.active]="currentLanguage === 'nl'"
        (click)="setLanguage('nl')"
        type="button"
        aria-label="Nederlands">
        NL
      </button>
    </div>

    <!-- Bouton FAQ avec icône shield-exclamation -->
    <button
      class="faq-button-figma"
      (click)="navigateToFAQ()"
      type="button"
      aria-label="Questions fréquemment posées">

      <!-- Icône FAQ (shield-exclamation) -->
      <img
        src="assets/images/shield-exclamation.svg"
        alt="FAQ icon"
        class="faq-icon-figma">

      <!-- Texte FAQ -->
      <span class="faq-text-figma">{{ 'NAVIGATION.FAQ' | productionTranslate }}</span>
    </button>

  </div>
</div>